import { stockMasterActionTypes } from '@Actions/inventory/stockMasterActions';

const StockMasterReducers = (state = { }, action) => {
  switch (action.type) {
  case stockMasterActionTypes.GET_BATCHES_DATA.LOADING: {
    const { getBatchesDataLoading } = action;
    return {
      ...state,
      getBatchesDataLoading,
    };
  }
  case stockMasterActionTypes.GET_BATCHES_DATA.SUCCESS: {
    const { batchesData } = action;
    return {
      ...state,
      batchesData,
    };
  }
  case stockMasterActionTypes.UPDATE_BATCH_DATA.LOADING: {
    const { updateBatchesLoading } = action;
    return {
      ...state,
      updateBatchesLoading,
    };
  }
  case stockMasterActionTypes.ADJUST_BATCH.LOADING: {
    const { adjustBatchesLoading } = action;
    return {
      ...state,
      adjustBatchesLoading,
    };
  }
  case stockMasterActionTypes.DELETE_BATCH_DATA.LOADING: {
    const { deleteBatchesLoading } = action;
    return {
      ...state,
      deleteBatchesLoading,
    };
  }
  case stockMasterActionTypes.GET_PRODUCT_LIST.LOADING: {
    const { getProductListLoading } = action;
    return {
      ...state,
      getProductListLoading,
    };
  }
  case stockMasterActionTypes.GET_PRODUCT_LIST.SUCCESS: {
    const { productLists } = action;
    return {
      ...state,
      productLists,
    };
  }
  case stockMasterActionTypes.GET_PRODUCT_LIST_BY_ID.LOADING: {
    const { getProductListByIdLoading } = action;
    return {
      ...state,
      getProductListByIdLoading,
    };
  }
  case stockMasterActionTypes.GET_PRODUCT_LIST_BY_ID.SUCCESS: {
    const { selectedProductList } = action;
    return {
      ...state,
      selectedProductList,
    };
  }
  case stockMasterActionTypes.CREATE_PRODUCT_LIST.LOADING: {
    const { createProductListLoading } = action;
    return {
      ...state,
      createProductListLoading,
    };
  }
  case stockMasterActionTypes.UPDATE_PRODUCT_LIST.LOADING: {
    const { updateProductListLoading } = action;
    return {
      ...state,
      updateProductListLoading,
    };
  }
  case stockMasterActionTypes.ADD_PRODUCT_TO_LIST.LOADING: {
    const { addProductToListLoading } = action;
    return {
      ...state,
      addProductToListLoading,
    };
  }
  case stockMasterActionTypes.REMOVE_PRODUCT_FROM_LIST.LOADING: {
    const { removeProductFromListLoading } = action;
    return {
      ...state,
      removeProductFromListLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default StockMasterReducers;
